import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import {UserParam, CustomModalData, Formes, Chantier} from './json-interface';
import { TranslateService } from '@ngx-translate/core';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CST_LOCALSTORAGE_VALUE } from './const';
import * as md5 from 'md5'; // Pour hash text
import { g_params } from './global-param';
import { NativeDateAdapter } from '@angular/material/core';

export class CUtilit {

  public static hashMD5(value: string): string {
    return md5(value);
  }

  public static boolToStr(val: boolean): string {
    return val ? '1' : '0';
  }

  public static setUserName(userName: string) {
    sessionStorage.setItem(CST_LOCALSTORAGE_VALUE.User, userName);
  }

  public static getUserName(): string {
    return sessionStorage.getItem(CST_LOCALSTORAGE_VALUE.User) || '';
  }

  /**
   * Recup depuis les param
   * Sinon retourne le premier chantier dispo dans g_params
   * Sinon retourne la valeur par default
   * @param defValIfNone Valeur par default si pas de chantier enregistré
   */
  public static getSelectedSiteCode(defValIfNone: string = ''): string {
    const ssSelectedSiteCode = sessionStorage.getItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode);
    if (ssSelectedSiteCode)      // Si existe dans session storage
      return ssSelectedSiteCode;
    else if (g_params.g_arraySite && g_params.g_arraySite.length > 0)         // Sinon retourne le premier chantier disponible dans la liste
      return g_params.g_arraySite[0].CODECHANTIER;
    return defValIfNone;                                                      // Sinon retourne rien
  }

  public static getSelectedSite(): Chantier|undefined {
    const siteCode = this.getSelectedSiteCode();
    for (let i = 0 ; i < g_params.g_arraySite.length ; i++)
      if (g_params.g_arraySite[i].CODECHANTIER == siteCode)
        return g_params.g_arraySite[i];

    return undefined;
  }

  /**
   * @return le code usine associé au chantier ou zéro
   */
  public static get selectedDefaultFactory(): number {
    const selectedSite = this.getSelectedSite();
    return selectedSite ? selectedSite.DEFAULT_FACTORY : 0;
  }

  public static LogoutAngular(router: Router) {
    this.setUserName('');
    sessionStorage.removeItem(CST_LOCALSTORAGE_VALUE.SelectedSiteCode);
    router.navigateByUrl('login');
  }

  public static sleep(timeout: number) {
    return new Promise(resolve => setTimeout(resolve, timeout));
  }

  /**
   *
   * @param matSnackBar       MatSnackBar
   * @param translateService  TranslateService, utiliser pour traduire les text, undefined pour ne pas traduire
   * @param message           String qui contiens le text a afficher
   * @param textBtn           String qui contiens le text du bouton a afficher, pas de btn si pas de texte
   * @param durationSecond    Nb de seconde avant que la snackbar disparaise
   * @param redSnackBar       Couleur de fond de la snackbar
   * @returns Une pomise qui contiens l'observable du click sur le bouton...
   *          Call next lors du click & complete a le fermeture de la snackbar.
   */
  public static async showSnackBar(matSnackBar: MatSnackBar,
                                   translateService: TranslateService | undefined,
                                   message: string,
                                   textBtn?: string,
                                   durationSecond: number = 5,
                                   redSnackBar: boolean = false): Promise<Observable<void>> {
    if (translateService) {
      if (message)
        message = await translateService.get(message).toPromise();
      if (textBtn)
        textBtn = await translateService.get(textBtn).toPromise();
    }
    const durationMs = durationSecond * 1000;
    const snackBarConfig: MatSnackBarConfig = {};
    snackBarConfig.duration = durationMs;
    if (redSnackBar)
      snackBarConfig['panelClass'] = ['red-snackbar'];
    const currentSnackBar = matSnackBar.open(message, textBtn, snackBarConfig);
    return currentSnackBar.onAction();
  }

  public static radToDegree(rad: number) {
    //1rad × 180/π
    return rad * (180 / Math.PI);
  }

  public static toRadian(degree: number) {
    return (degree - 90) * Math.PI / 180;
  }

  public static degToRadian(degree: number): number {
    return degree * (Math.PI / 180);
  }

  /**
   * Pour passage de la date vers delphi type TDateTime
   */
  public static convertDateToYYY_MM_DD(today: Date): string {
    let JJ: string = today.getDate().toString();
    let MM: string = (today.getMonth() + 1).toString();
    const YYYY = today.getFullYear();
    if (+JJ < 10) {
      JJ = '0' + JJ;
    }
    if (+MM < 10) {
      MM = '0' + MM;
    }
    return YYYY + '-' + MM + '-' + JJ;
  }

  public static getBeginMonth(): Date {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  public static getEndMonth(): Date {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  public static getNgStyleBorderColor(armaorColor: boolean, SiteClientColor: boolean): any {
    return {
      'red-m-arma-border': armaorColor,
      'medium-border-arma-color': SiteClientColor,
    };
  }

  public static getNgStyleBackgroundColor(armaorColor: boolean, SiteClientColor: boolean) {
    return {
      'armaor-red-bg-color': armaorColor,
      'armaor-background-color': SiteClientColor
    };
  }

  public static getArmaorUserColorCode(): any {
    return '#CB4545';
  }

  public static getUserSiteColorCode(): any {
    return 'rgba(17, 97, 143, 1)';
  }

  public static scrollDocumentToTop(element: HTMLElement | null) {
    if (element) {
      element.scrollTo(0, 0);
    } else {
      console.warn('scrollDocumentToTop: element unknown', element);
    }
  }

  public static async showAlertSessionExpired(snackBar?: MatSnackBar) {
    if (snackBar)
      this.showSnackBar(snackBar, undefined, 'Session expired !').catch(console.error);
    console.log('Session expired !');
  }

  /**
   * Retourne le margin top & bottom de l'element
   */
  public static getVerticalMarin(element: HTMLElement): number {
    const elemStyle = getComputedStyle(element);
    return parseFloat(elemStyle.marginTop) + parseFloat(elemStyle.marginBottom);
  }

  /**
   * @param resetParam boolean pour definir que l'on efface & recuperer les parametres par default
   * Recuperer les parametre enregistré dans le cache de l'utilisateur et initialiser les parametres non définit (undefined)
   */
  public static initUserParam(resetParam: boolean = false): UserParam {
    // Parametre par default de l'utilisateur
    const defaultUserParam: UserParam = {
      AnalysisInputType: 'Classical',
      InputPreviousDiamter: false,
      InputPreviousGrade: false,
      InputPreviousMeasure: false,
      InputPreviousQty: false,
      InputPreviousShape: false,
      ShowMemberColumn: true,
      InputPreviousBM: 'number',
      InputDistribution: true,
      ImageType: 'Full',
      SteelStock: false,
      AnalysisHideComment: false
    };
    let userParam: UserParam | undefined = this.loadUserParam();
    if (!userParam)
      userParam = defaultUserParam; // Si on a pas d'user param de definit alors on recupere les parametre par default
    else {
      // Si des param sont déja présent dans le local storage alors on check si on a aucun undefined le storage (nouveau params)
      Object.keys(defaultUserParam).forEach(key => {
        //const keyOfUserParam = (key as keyof UserParam);
        // Si on a un undefine, alors on change sa valeur en la valeur par default #defaultUserParam
        // @ts-ignore // TODO: TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'UserParam'.   No index signature with a parameter of type 'string' was found on type 'UserParam'.
        if (userParam[key] === undefined) userParam[key] = defaultUserParam[key];
      });
    }
    this.saveUserParam(userParam); // On resauvegarde les parametres dans le localstorage
    return userParam;
  }

  public static loadUserParam(): UserParam | undefined {
    let result: UserParam | undefined = undefined;
    const strParam: string | null = localStorage.getItem(CST_LOCALSTORAGE_VALUE.UserParam);
    if (strParam)
      result = JSON.parse(strParam);  // Verifie si le contenue du storage n'est pas undefined pour eviter de plancer a la conversion
    return result;
  }

  public static loadOrInitUserParam(): UserParam {
    const userParam = this.loadUserParam();
    if (!userParam)
      return this.initUserParam();
    return userParam;
  }

  public static saveUserParam(param: UserParam) {
    localStorage.setItem(CST_LOCALSTORAGE_VALUE.UserParam, JSON.stringify(param));
  }


  public static getNextLetter(value: string): string {
    const arrayLetterUP = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    function isLetterBM(letter: string): boolean {
      if (!letter) return true;  // Si rien n'est définit, ca peut etre une lettre
      for (let i = 0 ; i < letter.length - 1 ; i++)
        if (!arrayLetterUP.includes(letter.charAt(i).toUpperCase())) return false;
      return true;
    }

    if (!isLetterBM(value)) return '';      // Si l'entré n'est pas une lettre alors on retourne rien
    let result = '';                        // Init de la valeur de retour
    let indexValue = value.length - 1;        //
    let incNextValue = false;               //
    // On boucle sur la chaine de chara pour incrementer chaque charatere
    // On lit a partire de la fin jusqu'au début
    do {
      if (
        (arrayLetterUP.indexOf(value.charAt(indexValue)) == arrayLetterUP.length - 1 && incNextValue) ||                      // On est sur un Z & on doit incrémenté
        ((arrayLetterUP.indexOf(value.charAt(indexValue)) == arrayLetterUP.length - 1) && (indexValue == value.length - 1))     // On est sur un Z & on a la premiere value
      ) {    // Si on est sur la lettre Z
        result = arrayLetterUP[0] + result;   // On remplace le Z par un A
        incNextValue = true;                  // Et on indique que l'on doit incrémenter le prochain charactere
        if (indexValue == 0) result = arrayLetterUP[0] + result;  // Si on est sur le dernier chara a traiter alors on ajout un A au début du la chaine
      } else if (indexValue == value.length - 1 || incNextValue) {                          // Si on est sur la premiere valeur ou que l'on incrémente la décimal
        result = arrayLetterUP[arrayLetterUP.indexOf(value.charAt(indexValue).toUpperCase()) + 1] + result;
        incNextValue = false;                 // On indique que l'on a fait l'incrémentation
      } else {                                                                            // Cas par default
        result = value.charAt(indexValue) + result; // On va retourné le character X passé dans la chaine sans faire de modification
      }
      indexValue--;
    } while (indexValue >= 0);
    return result;
  }

  //Renvoi la liste des inputs sur une ligne du décorticage (sur une ligne de la grille)
  public static findInputsInHtmlElement(htmlElement?: HTMLElement | null): HTMLInputElement[] {
    if (!htmlElement)
      return [];
    const arrayOfInput: HTMLInputElement[] = [];
    for (let i = 0; i < htmlElement.childElementCount; i++) {
      const child = htmlElement.children.item(i);
      if (child instanceof HTMLInputElement) {
        arrayOfInput.push(child);
      } else if (child instanceof HTMLElement) {
        const arrayOfChildInput = this.findInputsInHtmlElement(child);
        arrayOfChildInput.forEach(htmlInput => {
          arrayOfInput.push(htmlInput);
        });
      }
    }
    return arrayOfInput;
  }

  public static findFocusableInputWithTabIndex(htmlElement: HTMLElement, currentFocusedInput?: HTMLInputElement): {
    arrayInput: HTMLInputElement[],
    idFocusedInput: number|undefined
  } {
    /**Tout les inpuste trié avec le tab index */
    const arrayInput: HTMLInputElement[] = [];
    let currentIdFocusedInput: number | undefined = undefined;

    /**Tout les input sans prendre en compte le tab index */
    const tempArrayInput: HTMLInputElement[] = [];

    let maxTabIndex: number = Number.MIN_VALUE;
    let minTabIndex: number = Number.MAX_VALUE;

    // On ajoute seulement les input que l'on peut focus (pas disabled)
    this.findInputsInHtmlElement(htmlElement).forEach(input => {
      if (!input.disabled) {
        tempArrayInput.push(input);
        maxTabIndex = Math.max(input.tabIndex, maxTabIndex);
        minTabIndex = Math.min(input.tabIndex, minTabIndex);
      }
    });

    // On trie les input par l'ordre tu tab index
    for (let currentTabIndex = minTabIndex ; currentTabIndex <= maxTabIndex ; currentTabIndex++) {
      for (let j = 0 ; j < tempArrayInput.length ; j++) {
        if (tempArrayInput[j].tabIndex == currentTabIndex) {
          arrayInput.push(tempArrayInput[j]);
          // Si on ajoute l'input passé en param, on indique l'id de l'input focused
          if (tempArrayInput[j] === currentFocusedInput)
            currentIdFocusedInput = arrayInput.length - 1;
        }
      }
    }

    return { arrayInput: arrayInput, idFocusedInput: currentIdFocusedInput};
  }

  /**
   * Recherche dans l'element tout les input disponible et les trie en fonction du tab index pour returner le prochain input (pour le focus)
   * @param htmlElemWithInputInside Html elemnt dans lesquel se trouve TOUT les inputs que l'on souhaite focus
   * @param htmlInput l'input que l'on est en train de focus
   * @param getPreviousInput boolean pour indique que l'on veux le precedent input
   * @returns ?
   */
  public static getNextFocusableInput(htmlElemWithInputInside: HTMLElement | null,
                                      htmlInput: HTMLInputElement,
                                      getPreviousInput: boolean): HTMLInputElement|undefined {
    if (htmlElemWithInputInside == null)
      return undefined;
    let input: HTMLInputElement|undefined = undefined;

    // On recup tout les input de l'elem
    const focusableInput = CUtilit.findFocusableInputWithTabIndex(htmlElemWithInputInside, htmlInput);

    // Début algo
    if (focusableInput.arrayInput.length == 0) { // On à pas trouvé d'input, on fait rien
      return;
    } else if (focusableInput.arrayInput.length == 1) { // 1 input, on focus tjr le même
      input = focusableInput.arrayInput[focusableInput.arrayInput.length - 1]; // On focus toujours le même input
    } else if (focusableInput.idFocusedInput !== undefined) { // Plusieurs input + on a trouvé l'input en cours, on peut tenter de focus le suivant/precedent
      if (!getPreviousInput) {
        // check si il y a un prochain input sinon on focus le premier
        if (focusableInput.arrayInput.length - 1 == focusableInput.idFocusedInput) {
          input = focusableInput.arrayInput[0];
        } else {
          input = focusableInput.arrayInput[focusableInput.idFocusedInput + 1];
        }
      } else {
        // check si il y a un precedent input sinon on focus le dernier
        if (focusableInput.idFocusedInput == 0) {
          // Focus du dernier input
          input = focusableInput.arrayInput[focusableInput.arrayInput.length - 1];
        } else {
          // Focus de l'input precedent
          input = focusableInput.arrayInput[focusableInput.idFocusedInput - 1];
        }
      }
    }
    return input;
  }

  /**
  * Passe le chemin d'un fichier et retourne le nom du fichier seul
  */
  public static getFileNameFromPath(path: string) {
    let filename = '';
    if (path) filename = path.replace(/^.*[\\\/]/, '');
    return filename;
  }

  public static getFirstDayOfTheDate(date: Date = new Date()): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  public static getLastDayOfTheDate(date: Date = new Date()): Date {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  public static findShape(shapeCode: string, shape: Formes[]): Formes | undefined {
    for (let i = 0; i < shape.length; i++) {
      const element = shape[i];
      if (element.CodeForme == shapeCode)
        return element;
    }
    return undefined;
  }

  public static numToStr(value: number, nbZero: number = 0): string {
    let s: string = value.toString();
    while (s.length < nbZero)
      s = '0' + s;
    return s;
  }
                                                        //{1,2,4}
  //Transforme un entier en tableau de ses bits ex:   5 = [1,0,1]
  public static IntToBinArray(value: number): number[] {
    const result: number[] = [];
    const base2 = (value).toString(2);
    Array.from(base2).forEach(char => {
      result.unshift(char == '1' ? 1 : 0); //Ajoute à l'avant du tableau pour avoir index 0 = le plus petit nombre binaire
    });
    return result;
  }
}

// FIN DE CUtilit
//////////////////

/**
 * Retourne le nom de la propriété de l'interface
 * @param name nom de la propriété de l'interface
 */
export const nameof = <T>(name: keyof T) => name;

export const doArrayFlat = (anArray: any[]): any[] => {
  return anArray.reduce((previousValue, currentValue) => previousValue.concat(currentValue), []);
};

export const getJsonLocalStorage = <T>(key: string, defaultValue: T | {} = {}): T | {} => {
  try {
    const item = localStorage.getItem(key);
    if (!item)
      return defaultValue;
    const jsonLocalStorage = JSON.parse(item);
    // Verification des champ undefine
    for (const jsKey in (defaultValue as T)) {
      if (jsonLocalStorage[jsKey] === undefined)
        jsonLocalStorage[jsKey] = (defaultValue as T)[jsKey];
    }
    return jsonLocalStorage;
  } catch (e) {
    console.error('getJsonLocalStorage', e);
    return defaultValue;
  }
};

/**
 * gerer l'ajout & la supression de cookie....
 * Source: https://www.w3schools.com/js/js_cookies.asp
 */
export class CookieManagment {

  /**
   *
   * @param cname  name of the cookie
   * @param cvalue the value of the cookie
   * @param exdays number of hours until the cookie should expire
   */
  public static setCookie(cname: any, cvalue: any, exdays: any) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  public static removeCookie(cname: any) {
    document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
  }

  /**
   *
   * @param cname name of the cookie
   * @returns value of a specified cookie
   */
  public static getCookie(cname: any) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  /**
   * TODO: à tester pour les cas null ou undefined
   * @param cname name of the cookie
   */
  public static hasCookie(cname: any): boolean {
    return this.getCookie(cname) != '';
  }
}

/**
 * Reprend la date en js mais ajoute des fonction pour simplifier son utilisation avec armaserv
 * A savoir :
 *  - Depuis delphi il faut exporter le DateTime en UnixTimestamp avec la fonction DateTimeToUnix()
 *  - Quand on doit envoyer des date au server il faut les passer en UnixTimestamp et les recuperer sur delphi avec la fonction UnixToDateTime()
 */
export class ArmaDate {

  public static CST_DATE_ZERO_ARMAOR = -2209161600;
  public static CST_DATE_SEPARATOR = '-';
  public static CST_TIME_SEPARATOR = ':';

  private mDateZeroArmaor = ArmaDate.CST_DATE_ZERO_ARMAOR;

  private constructor(private mDate: Date) {}

  /**
   * Crée depuis une unixTimestamp, généralement date sur delphi
   * Résultat sous delpgi de l'appel DateTimeToUnix() avec comme param la date un TDate ou TDateTime
   * DateTimeToUnix() retourn un number qui correspond a la date unix
   * @param unixTimestamp Resultat de la date DateTimeToUnix() sous delphi
   */
  public static createFromUnixTime(unixTimestamp: number): ArmaDate {
    function forceToTimeZone(date: Date): Date {
      const newDate = new Date();
      newDate.setFullYear(date.getUTCFullYear());
      newDate.setMonth(date.getUTCMonth());
      newDate.setDate(date.getUTCDate());
      newDate.setHours(date.getUTCHours());
      newDate.setMinutes(date.getUTCMinutes());
      newDate.setSeconds(date.getUTCSeconds());
      return newDate;
    }
    return new ArmaDate(forceToTimeZone(new Date(unixTimestamp * 1000)));
  }

  /**
   * Crée depuis le JS
   * @param date Date
   */
  public static createFromDate(date: Date): ArmaDate {
    return new ArmaDate(date);
  }

  public static toClonnedDate(unixTimestamp: number): Date {
    return this.createFromUnixTime(unixTimestamp).getClonnedDate();
  }

  public static toUnixTimestamp(date: Date): number {
    return this.createFromDate(date).toUnixTimestamp();
  }

  private isDateZeroArmaor(): boolean {
    return (this.mDateZeroArmaor == this.toUnixTimestamp());
  }

  public toUnixTimestamp(): number {
    function forceToUTC(date: Date): Date {
      const newDate = new Date(0, 0, 0, 0, 0, 0, 0);
      newDate.setUTCFullYear(date.getFullYear());
      newDate.setUTCMonth(date.getMonth());
      newDate.setUTCDate(date.getDate());
      // On reafecte le mois a nouveaux car il est possible que l'on affecter le mois de fevrier qui contiens 28jour alors que la date zero est sur 30jous, donc on passe au mois suivant
      newDate.setUTCMonth(date.getMonth());
      newDate.setUTCHours(date.getHours());
      newDate.setUTCMinutes(date.getMinutes());
      newDate.setUTCSeconds(date.getSeconds());
      return newDate;
    }
    return Math.floor(forceToUTC(this.mDate).getTime() / 1000); // floor = round down pour enlever la precision de js qui n'est pas utiilsé sous unix
  }

  getClonnedDate(): Date {
    return new Date(this.mDate);
  }

  public toDate(separator: string = ArmaDate.CST_DATE_SEPARATOR): string {
    if (this.isDateZeroArmaor())
      return '';
    const JJ = this.mDate.getDate();
    const MM = this.mDate.getMonth() + 1;
    const YYYY = this.mDate.getFullYear();
    // les formats qui suivent se basent sur le
    // fuseau horaire CEST
    // l'anglais américain utilise l'ordre mois-jour-année → "12/20/2012"
    // le coréen utilise l'ordre année-mois-jour "ko-KR" → "2012. 12. 20."
    // l'arabe, dans la plupart des pays arabophones, utilise les chiffres arabes "ar-EG" → "٢٠‏/١٢‏/٢٠١٢"
    // en ce qui concerne le japonais, les applications peuvent
    // souhaiter utiliser le calendrier japonais
    // pour lequel 2012 était l'année 24 de l'ère Heisei "ja-JP-u-ca-japanese" → "24/12/20"

    // Par default on retourne le format fr
    // l'anglais britannique utilise l'ordre jour-mois-année "en-GB → "20/12/2012"
    // Fr -> jour/mois/année
    return CUtilit.numToStr(JJ, 2) + separator + CUtilit.numToStr(MM, 2) + separator + YYYY;
  }

  public toTime(separator: string = ArmaDate.CST_TIME_SEPARATOR) {
    const HH = this.mDate.getHours();
    const MM = this.mDate.getMinutes();
    const ss = this.mDate.getSeconds();
    return CUtilit.numToStr(HH, 2) + separator + CUtilit.numToStr(MM, 2) + separator + CUtilit.numToStr(ss, 2);
  }

  public toDateTime(sepDate: string = ArmaDate.CST_DATE_SEPARATOR, sepTime: string = ArmaDate.CST_TIME_SEPARATOR) {
    return this.toDate(sepDate) + ' ' + this.toTime(sepTime);
  }
}

export class ModalUtilit {
  public static async warModal2btn(dialog: MatDialog, text: string, title: string = 'Avertissement'): Promise<boolean> {
    const customData: CustomModalData = {
      Title: title,
      Button: [
        {ButtonText: 'Validate', ResultValue: true},
        {ButtonText: 'Annuler', ResultValue: false},
      ],
      Message: [text]
    };
    const dialogRef = dialog.open(CustomModalComponent, {
      disableClose: true,
      width: '350px',
      data: customData
    });
    return await dialogRef.afterClosed().toPromise();
  }

  public static async yesNoCancel(dialog: MatDialog, text: string, title: string = 'Information'): Promise<boolean> {
    const customData: CustomModalData = {
      Title: title,
      Button: [
        {ButtonText: 'Oui', ResultValue: true},
        {ButtonText: 'Non', ResultValue: false},
        {ButtonText: 'Annuler', ResultValue: undefined}
      ],
      Message: [text]
    };
    const dialogRef = dialog.open(CustomModalComponent, {
      disableClose: true,
      width: '350px',
      data: customData
    });
    return await dialogRef.afterClosed().toPromise();
  }

  public static async yesNo(dialog: MatDialog, text: string, title: string = 'Information'): Promise<boolean> {
    const customData: CustomModalData = {
      Title: title,
      Button: [
        {ButtonText: 'Yes', ResultValue: true},
        {ButtonText: 'Non', ResultValue: false},
      ],
      Message: [text]
    };
    const dialogRef = dialog.open(CustomModalComponent, {
      disableClose: true,
      width: '350px',
      data: customData
    });
    return await dialogRef.afterClosed().toPromise();
  }
}

// PIPE
///////

/** Permet de transformer un charactere spécifique dans un string en un autre charactere */
@Pipe({name: 'splitePipe'})
export class SplitePipe implements PipeTransform {
  transform(value: string, ...args: any[]): string[] {
    return value.split(args[0]);
  }
}

/**
 *
 * @param value Kg weight
 * @param args  Useless
 */
@Pipe({name: 'toTonne'})
export class ConvertToTonne implements PipeTransform {
  transform(value: number, ...arg: any[]): number {
    if (!isNaN(value))
      value = value / 1000;
    return value;
  }
}

@Pipe({name: 'onlyNumSupZero'})
export class ShowOnlyNumberSupToZeroPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    let result = '';
    if (!isNaN(value) && value > 0)
      result = value;
    return result;
  }
}

// Composant indépenant
///////////////////////

/**
 * Fonctionne avec la class ModalUtilit
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'custom-modal-dialog',
  templateUrl: '../components/dialog/custom-modal.html'
})
export class CustomModalComponent {

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomModalData
    ) {
  }

  onBtnModalClick(event: any, button: any) {
    this.dialogRef.close(button.ResultValue);
  }

  get dialogTitle(): string {
    return this.data.Title;
  }

  get arrayMessage(): string[] {
    return this.data.Message;
  }

  get arrayButton(): any {
    return this.data.Button;
  }
}

// Todo mettre à jour avec le custom modal
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'alert-dialog',
  templateUrl: '../components/dialog/alert-dialog.html'
})
export class AlertDialogComponent {

  mDialogTitle: string;
  mDialogInformation: string;
  mDialogInformation2: string;

  public static showDialog(dialog: MatDialog, title: string, information?: string, information2?: string): MatDialogRef<AlertDialogComponent, boolean> {
    return dialog.open(
      AlertDialogComponent,
      {
        disableClose: true,
        data: {
          'title': title,
          'information': information,
          'information2': information2
        }
      }
    );
  }

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.mDialogTitle = data.title;
      this.mDialogInformation = data.information;
      this.mDialogInformation2 = data.information2;
  }

  onYesClick() {
    this.dialogRef.close(true);
  }

  onNoClick() {
    this.dialogRef.close(false);

  }
}

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}
